
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attribution",
      function () {
        return require("private-next-pages/attribution.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attribution"])
      });
    }
  